import { render, staticRenderFns } from "./AlertRSTable.vue?vue&type=template&id=51c708f6&scoped=true&"
import script from "./AlertRSTable.vue?vue&type=script&lang=js&"
export * from "./AlertRSTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertRSTable.vue?vue&type=style&index=0&id=51c708f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c708f6",
  null
  
)

export default component.exports